import request from '../index.js'

// 认证管理API - 连接真实后端API
export const authApi = {
  // 管理员登录 - 使用真实API
  login(data) {
    return request({
      url: '/auth/login',
      method: 'post',
      data
    })
  },

  // 管理员登出 - 使用真实API
  logout() {
    return request({
      url: '/auth/logout',
      method: 'post'
    })
  },

  // 获取管理员信息 - 使用真实API
  getAdminInfo() {
    return request({
      url: '/auth/profile',
      method: 'get'
    })
  },

  // 刷新token - 使用真实API
  refreshToken() {
    return request({
      url: '/auth/refresh',
      method: 'post'
    })
  },

  // 修改密码 - 使用真实API
  changePassword(data) {
    return request({
      url: '/auth/change-password',
      method: 'post',
      data
    })
  },

  // 获取权限列表 - 使用真实API
  getPermissions() {
    return request({
      url: '/auth/permissions',
      method: 'get'
    })
  },

  // 获取菜单列表 - 使用真实API
  getMenus() {
    return request({
      url: '/auth/menus',
      method: 'get'
    })
  }
}

export default authApi
